import { Form, FormikProps } from "formik";
import {
  CabinContentsProductIntroFormValues,
  CabinContentsTexts,
} from "../cabinContentsInterfaces";

import { Paragraph } from "App/global-style";
import { MarketingConsent } from "Components/Consent/MarketingConsent";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { ProductIntroTile } from "Components/Features/CheckPrice/Tiles/ProductIntroTile";
import { PartnerProductIntroForms } from "Components/Features/CheckPrice/Tiles/ProductIntroTile/PartnerProductIntroForms/PartnerProductIntroForms";
import { ErrorsSummedUpRender } from "Components/Form/ErrorsSummedUp";
import { PostNumberAndCity } from "Components/Form/PostNumberAndCity";
import { NavigationButtons } from "Components/NavigationButtons";
import { ScrollToFirstError } from "Components/ScrollToFirstError";
import { useTexts } from "Components/TextContext";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { useFormState } from "Store/priceCalculation/priceCalculationHooks";
import { updatePriceCalculationFormState } from "Store/priceCalculation/priceCalculationSlice";
import { nextStep } from "Store/steps/stepsSlice";
import { getFMSProductName } from "Store/texts/helpers/FMSproductName";
import { useProductTexts } from "Store/texts/hooks";
import { mapValidationErrors } from "Utils/formUtils";
import React from "react";
import { useDispatch } from "react-redux";
import { CABIN_CONTENTS_INTRO_STEP } from "../CabinContentsSteps";
import { validationSchema } from "./cabinContentsProductIntroValidation";

export const CabinContentsProductIntro = (): React.ReactElement => {
  const dispatch = useDispatch();

  const [
    {
      formText: { findCabinContents },
      details,
    },
    lang,
  ] = useProductTexts<CabinContentsTexts>(
    getFMSProductName(INSURANCE_NAME_VALUE.CABIN_CONTENTS),
  );
  const { getText } = useTexts();
  const initialFormState = useFormState<CabinContentsProductIntroFormValues>(
    CABIN_CONTENTS_INTRO_STEP.id,
    initialFormValues,
  );

  const handleSubmit = (
    formValues: CabinContentsProductIntroFormValues,
  ): void => {
    dispatch(
      updatePriceCalculationFormState({
        stepId: CABIN_CONTENTS_INTRO_STEP.id,
        formState: {
          ...formValues,
        },
      }),
    );
    dispatch(nextStep());
  };

  return (
    <ProductIntroTile
      productBackendName={ProductBackendName.CABIN_CONTENTS}
      initialValues={initialFormState}
      validationSchema={validationSchema()}
      onSubmit={handleSubmit}
    >
      {(formProps: FormikProps<CabinContentsProductIntroFormValues>) => {
        return (
          <Form>
            <Paragraph>{findCabinContents.ingress[lang]}</Paragraph>
            <PostNumberAndCity
              formProps={formProps}
              label={getText("cabincontentsform.label.postnumber")}
            />

            <PartnerProductIntroForms />
            <MarketingConsent />

            <ErrorsSummedUpRender
              formProps={formProps}
              errors={mapValidationErrors(formProps.errors, details, lang)}
              isVisible
            />
            <ScrollToFirstError />
            <NavigationButtons hidePreviousButton />
          </Form>
        );
      }}
    </ProductIntroTile>
  );
};

const initialFormValues = {
  postNumber: undefined,
  city: undefined,
  validPostNumber: undefined,
};
